import round from 'lodash/round';

const EXPONENTIAL_ZOOM_BASE = 2;
const LOGRAITHMIC_ZOOM_BASE = Math.log(2);
export const LINEAR_ZOOM_STEP = 0.1;

export const MAXIMUM_LINEAR_ZOOM = 1;
export const MINIMUM_LINEAR_ZOOM = -1;
const ZOOM_COMPARISON_PRECISION = 5;

// convert exponential diagram zoom to a linear ak-range accessible value
export const getLinearZoom = (exponentialZoom: number): number =>
	Math.log(exponentialZoom) / LOGRAITHMIC_ZOOM_BASE;

// convert linear ak-range value to exponential diagram zoom value
export const getExponentialZoom = (linearZoom: number) => EXPONENTIAL_ZOOM_BASE ** linearZoom;

export const isMinimumZoom = (exponentialZoom: number) =>
	round(exponentialZoom, ZOOM_COMPARISON_PRECISION) === MINIMUM_LINEAR_ZOOM;

export const isMaximumZoom = (exponentialZoom: number) =>
	round(exponentialZoom, ZOOM_COMPARISON_PRECISION) === MAXIMUM_LINEAR_ZOOM;
